<template>
    <div>
        <Header />

        <!-- 毛毛蟲 -->
        <nav aria-label="breadcrumb" class="breadcrumb_box">
            <div class="container">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/" title="首頁">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Recommendation Letter
                    </li>
                </ol>
            </div>
        </nav>

        <div class="main form profile_box recommenders_box">
            <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
                onclick="document.getElementById('accesskey_c').scrollIntoView();">
                :::
            </a>

            <div class="container">
                <!-- Loading State -->
                <div v-if="loading" class="box">
                    <div class="title">
                        <h2>Loading...</h2>
                    </div>
                    <div class="bg information_box">
                        <div class="form-group full" style="padding: 20px; text-align: center; border-radius: 4px;">
                            Please wait while we load the recommendation information...
                        </div>
                    </div>
                </div>

                <!-- Error State -->
                <div v-else-if="error" class="box">
                    <div class="title">
                        <h2>Error</h2>
                    </div>
                    <div class="bg information_box">
                        <div class="form-group full"
                            style="padding: 20px; color: red; text-align: center; border-radius: 4px;">
                            {{ errorMessage }}
                        </div>
                    </div>
                </div>

                <!-- Success State -->
                <div v-else-if="submitted" class="box">
                    <div class="title">
                        <h2>Success</h2>
                    </div>
                    <div class="bg information_box">
                        <div class="form-group full"
                            style="padding: 20px; color: green; text-align: center; border-radius: 4px;">
                            Thank you! Your recommendation letter has been submitted successfully.
                        </div>
                    </div>
                </div>

                <!-- Main Form -->
                <div v-else class="box">
                    <div class="title">
                        <h2>Recommendation Letter</h2>
                    </div>

                    <div class="bg information_box">
                        <div class="title_box">
                            <h3>Referee</h3>
                        </div>

                        <!-- 基本資料 -->
                        <ul class="basic_list">
                            <li class="full">
                                <p>Name</p>
                                <p>{{ recommender.name }}</p>
                            </li>

                            <li class="full">
                                <p>Job Title</p>
                                <p>{{ recommender.jobTitle }}</p>
                            </li>

                            <li class="full">
                                <p>School or Institute</p>
                                <p>{{ recommender.schoolOrInstitute }}</p>
                            </li>
                        </ul>
                    </div>

                    <div class="bg information_box">
                        <div class="title_box">
                            <h3>Student Information</h3>
                        </div>

                        <!-- 基本資料 -->
                        <ul class="basic_list">
                            <li class="full">
                                <p>Name</p>
                                <p>{{ student.chineseName }} ({{ student.englishName }})</p>
                            </li>

                            <li class="full">
                                <p>Apply ID</p>
                                <p>{{ student.applyID }}</p>
                            </li>

                            <li class="full">
                                <p>Contact Email</p>
                                <p>{{ student.contactEmail }}</p>
                            </li>

                            <li class="full">
                                <p>Program</p>
                                <p>
                                    {{ program.collegeName }}<br />
                                    {{ program.departmentName }} - {{ program.name }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <!-- Agree Type Selection -->
                    <div class="bg information_box">
                        <div class="title_box">
                            <h3>Recommendation Agreement</h3>
                        </div>

                        <div class="form-group full" style="padding: 20px;">
                            <label>Do you agree to provide a recommendation for this student? *</label>
                            <div style="margin-top: 15px;">
                                <label style="display: block; margin-bottom: 10px;">
                                    <input type="radio" v-model="form.agreeType" :value="1"
                                        style="margin-right: 5px;" />
                                    Yes, I agree to provide a recommendation
                                </label>
                                <label style="display: block; margin-bottom: 10px;">
                                    <input type="radio" v-model="form.agreeType" :value="2"
                                        style="margin-right: 5px;" />
                                    No, I do not agree to provide a recommendation
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Recommendation Letter Section - Only show if agreeType is 1 -->
                    <div v-if="form.agreeType === 1" class="bg recommendation_letter">
                        <div class="title_box">
                            <h3>Submit Recommendation Letter</h3>
                            <p v-if="deadline">
                                Please complete the recommendation letter
                                <span>by {{ deadline }}</span>
                                . Thank you.
                            </p>
                        </div>

                        <!-- Recommendation Method Selection -->
                        <div class="form-group full" style="margin-bottom: 20px;">
                            <label>Recommendation Method *</label>
                            <div style="margin-top: 10px;">
                                <label style="display: block; margin-bottom: 10px;">
                                    <input type="radio" v-model="form.recommendedMethod" :value="1"
                                        style="margin-right: 5px;" />
                                    Online Text Input
                                </label>
                                <label style="display: block; margin-bottom: 10px;">
                                    <input type="radio" v-model="form.recommendedMethod" :value="2"
                                        style="margin-right: 5px;" />
                                    Upload PDF File
                                </label>
                                <label style="display: block; margin-bottom: 10px;">
                                    <input type="radio" v-model="form.recommendedMethod" :value="3"
                                        style="margin-right: 5px;" />
                                    Mail directly to the institution
                                </label>
                                <label style="display: block;">
                                    <input type="radio" v-model="form.recommendedMethod" :value="4"
                                        style="margin-right: 5px;" />
                                    Sealed letter given to applicant for mailing
                                </label>
                            </div>
                        </div>

                        <!-- Online Text Input -->
                        <div v-if="form.recommendedMethod === 1" class="text_box">
                            <textarea v-model="form.recommendedContent" cols="30" rows="10"
                                placeholder="Please fill in your recommendation letter here..."
                                :disabled="submitting"></textarea>
                        </div>

                        <!-- File Upload -->
                        <div v-if="form.recommendedMethod === 2" class="form-group file_box full">
                            <label>Upload Recommendation Letter</label>

                            <div class="file_input">
                                <input type="file" ref="fileInput" class="form-control" accept=".pdf"
                                    @change="handleFileChange" :disabled="submitting || uploading" />

                                <div class="upload" @click="$refs.fileInput.click()">
                                    {{ uploading ? 'Uploading...' : 'Upload' }}
                                </div>
                            </div>

                            <p class="notice">
                                Kindly upload the file in PDF format, with a maximum size of
                                50MB.
                            </p>

                            <p v-if="uploadedFileName" style="margin-top: 10px; color: green;">
                                ✓ File uploaded: {{ uploadedFileName }}
                            </p>

                            <p v-if="uploadError" style="margin-top: 10px; color: red;">
                                {{ uploadError }}
                            </p>
                        </div>

                        <!-- Message for Mail Methods -->
                        <div v-if="form.recommendedMethod === 3" class="form-group full"
                            style="padding: 20px; background: #f8f9fa; border-radius: 4px;">
                            <p style="margin: 0; line-height: 1.6;">
                                <strong>Mail directly to the institution:</strong><br>
                                Please send your sealed recommendation letter directly to the institution address.<br>
                                The link will be marked as completed once you submit this form.
                            </p>
                        </div>

                        <div v-if="form.recommendedMethod === 4" class="form-group full"
                            style="padding: 20px; background: #f8f9fa; border-radius: 4px;">
                            <p style="margin: 0; line-height: 1.6;">
                                <strong>Sealed letter given to applicant:</strong><br>
                                Please provide a sealed recommendation letter to the applicant for mailing.<br>
                                The link will be marked as completed once you submit this form.
                            </p>
                        </div>

                        <!-- Validation Error -->
                        <div v-if="validationError" class="form-group full"
                            style="padding: 20px; background: #f8f9fa; color: red; text-align: center; border-radius: 4px;">
                            {{ validationError }}
                        </div>

                        <div class="btn_box">
                            <button class="btn" @click="handleSubmit" :disabled="submitting">
                                {{ submitting ? 'Submitting...' : 'Submit' }}
                            </button>
                        </div>
                    </div>

                    <!-- Message when disagree -->
                    <div v-if="form.agreeType === 2" class="bg recommendation_letter">
                        <div class="form-group full"
                            style="padding: 20px; background: #f8f9fa; text-align: center; border-radius: 4px;">
                            Thank you for your response. Your decision has been noted.
                        </div>
                        <div class="btn_box">
                            <button class="btn" @click="handleDecline" :disabled="submitting">
                                {{ submitting ? 'Submitting...' : 'Confirm' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import recommendationService from "@/services/recommendation.js";

export default {
    name: "Recommenders",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            linkCode: "",
            loading: true,
            error: false,
            errorMessage: "",
            submitted: false,
            submitting: false,
            uploading: false,
            uploadError: "",
            uploadedFileName: "",
            validationError: "",
            deadline: null,

            // Recommendation data from API
            recommendationLetter: null,
            recommender: {
                name: "",
                jobTitle: "",
                schoolOrInstitute: "",
                email: "",
            },
            student: {
                applyID: "",
                chineseName: "",
                englishName: "",
                contactEmail: "",
            },
            program: {
                pId: 0,
                name: "",
                name_EN: "",
                code: "",
                degree: 0,
                departmentName: "",
                departmentName_EN: "",
                collegeName: "",
                collegeName_EN: "",
            },
            apply: {
                endTime: "",
            },

            // Form data
            form: {
                agreeType: 0,
                recommendedMethod: 0,
                recommendedContent: "",
                recommendedFile: "",
            },
        };
    },

    async mounted() {
        window.scrollTo(0, 0);

        // Get linkCode from route params
        this.linkCode = this.$route.params.linkCode;

        if (!this.linkCode) {
            this.error = true;
            this.errorMessage = "Invalid recommendation link. Please check the URL.";
            this.loading = false;
            return;
        }

        // Fetch recommendation info
        await this.fetchRecommendationInfo();
    },

    watch: {
        /**
         * Clear validation error when agreeType changes
         */
        'form.agreeType'() {
            this.validationError = "";
        },

        /**
         * Clear validation error when recommendedMethod changes
         */
        'form.recommendedMethod'() {
            this.validationError = "";
        },
    },

    methods: {
        /**
         * Fetch recommendation information from API
         */
        async fetchRecommendationInfo() {
            this.loading = true;
            this.error = false;

            try {
                const result = await recommendationService.getRecommendationInfo(
                    this.linkCode
                );

                if (result.success && result.data) {
                    const data = result.data;

                    // Set recommendation letter data
                    this.recommendationLetter = data.recommendationLetter;

                    // Set recommender data
                    if (data.recommender) {
                        this.recommender = {
                            name: data.recommender.name || "",
                            jobTitle: data.recommender.jobTitle || "",
                            schoolOrInstitute: data.recommender.schoolOrInstitute || "",
                            email: data.recommender.email || "",
                        };
                    }

                    // Set student data
                    if (data.student) {
                        this.student = {
                            applyID: data.student.applyID || "",
                            chineseName: data.student.chineseName || "",
                            englishName: data.student.englishName || "",
                            contactEmail: data.student.contactEmail || "",
                        };
                    }

                    // Set program data
                    if (data.program) {
                        this.program = {
                            pId: data.program.pId || 0,
                            name: data.program.name || "",
                            name_EN: data.program.name_EN || "",
                            code: data.program.code || "",
                            degree: data.program.degree || 0,
                            departmentName: data.program.departmentName || "",
                            departmentName_EN: data.program.departmentName_EN || "",
                            collegeName: data.program.collegeName || "",
                            collegeName_EN: data.program.collegeName_EN || "",
                        };
                    }

                    // Set deadline if available (you can add this field to your API if needed)
                    // For now, using a placeholder
                    if (data.apply && data.apply.endTime) {
                        this.deadline = data.apply.endTime;
                    } else {
                        this.deadline = "the application deadline";
                    }
                } else {
                    this.error = true;
                    this.errorMessage =
                        result.message ||
                        "Failed to load recommendation information. The link may be invalid or expired.";
                }
            } catch (err) {
                this.error = true;
                this.errorMessage =
                    "An unexpected error occurred. Please try again later.";
                console.error("Error fetching recommendation info:", err);
            } finally {
                this.loading = false;
            }
        },

        /**
         * Handle file selection and upload
         */
        async handleFileChange(event) {
            const file = event.target.files[0];

            if (!file) {
                return;
            }

            // Reset previous upload state
            this.uploadError = "";
            this.uploadedFileName = "";
            this.form.recommendedFile = "";

            // Validate file type
            if (file.type !== "application/pdf") {
                this.uploadError = "Please upload a PDF file only.";
                this.$refs.fileInput.value = "";
                return;
            }

            // Validate file size (50MB max according to API documentation)
            const maxSize = 50 * 1024 * 1024; // 50MB in bytes
            if (file.size > maxSize) {
                this.uploadError = "File size must not exceed 50MB.";
                this.$refs.fileInput.value = "";
                return;
            }

            // Upload file
            this.uploading = true;

            try {
                const result = await recommendationService.uploadRecommendationFile(
                    this.linkCode,
                    file
                );

                if (result.success && result.filePreviewUrl) {
                    // Store the fileUrl returned from API (to be used in submission)
                    this.form.recommendedFile = result.filePreviewUrl;
                    this.uploadedFileName = file.name;
                    this.uploadError = "";
                } else {
                    this.uploadError =
                        result.message || "Failed to upload file. Please try again.";
                    this.$refs.fileInput.value = "";
                }
            } catch (err) {
                this.uploadError = "An error occurred while uploading the file.";
                console.error("Error uploading file:", err);
                this.$refs.fileInput.value = "";
            } finally {
                this.uploading = false;
            }
        },

        /**
         * Validate form before submission
         */
        validateForm() {
            // Check agree type
            if (!this.form.agreeType || this.form.agreeType === 0) {
                this.validationError = "Please select whether you agree to provide a recommendation.";
                return false;
            }

            // If disagree, no further validation needed
            if (this.form.agreeType === 2) {
                this.validationError = "";
                return true;
            }

            // Check recommendation method (only if agreed)
            if (this.form.agreeType === 1) {
                if (!this.form.recommendedMethod || this.form.recommendedMethod === 0) {
                    this.validationError = "Please select a recommendation method.";
                    return false;
                }

                // Check content based on method
                if (this.form.recommendedMethod === 1) {
                    if (!this.form.recommendedContent || !this.form.recommendedContent.trim()) {
                        this.validationError = "Please fill in the recommendation letter content.";
                        return false;
                    }
                } else if (this.form.recommendedMethod === 2) {
                    if (!this.form.recommendedFile) {
                        this.validationError = "Please upload a recommendation letter file.";
                        return false;
                    }
                }
                // For methods 3 and 4 (mail options), no content validation needed
            }

            this.validationError = "";
            return true;
        },

        /**
         * Handle form submission
         */
        async handleSubmit() {
            // Validate form
            if (!this.validateForm()) {
                return;
            }

            // Different confirmation messages based on method
            let confirmMessage = "Are you sure you want to submit this recommendation letter? Once submitted, it cannot be modified.";

            if (this.form.recommendedMethod === 3) {
                confirmMessage = "Please confirm that you will mail the recommendation letter directly to the institution. Once confirmed, this link will be marked as completed.";
            } else if (this.form.recommendedMethod === 4) {
                confirmMessage = "Please confirm that you will provide a sealed recommendation letter to the applicant. Once confirmed, this link will be marked as completed.";
            }

            // Confirm submission
            if (!confirm(confirmMessage)) {
                return;
            }

            this.submitting = true;
            this.validationError = "";

            try {
                // Prepare submission data
                const submitData = {
                    linkCode: this.linkCode,
                    agreeType: this.form.agreeType,
                    recommendedMethod: this.form.recommendedMethod,
                };

                // Add content or file based on method (only for methods 1 and 2)
                if (this.form.recommendedMethod === 1) {
                    submitData.recommendedContent = this.form.recommendedContent;
                } else if (this.form.recommendedMethod === 2) {
                    submitData.recommendedFile = this.form.recommendedFile;
                }
                // For methods 3 and 4, no content or file is needed

                // Submit recommendation
                const result = await recommendationService.submitRecommendation(
                    submitData
                );

                if (result.success) {
                    this.submitted = true;
                    window.scrollTo(0, 0);
                } else {
                    this.validationError =
                        result.message ||
                        "Failed to submit recommendation letter. Please try again.";
                }
            } catch (err) {
                this.validationError =
                    "An unexpected error occurred. Please try again later.";
                console.error("Error submitting recommendation:", err);
            } finally {
                this.submitting = false;
            }
        },

        /**
         * Handle decline (when user selects "No, I do not agree")
         */
        async handleDecline() {
            // Confirm decline
            if (
                !confirm(
                    "Are you sure you do not wish to provide a recommendation? This action will notify the applicant."
                )
            ) {
                return;
            }

            this.submitting = true;
            this.validationError = "";

            try {
                // Prepare submission data with agreeType = 2 (declined)
                const submitData = {
                    linkCode: this.linkCode,
                    agreeType: 2,
                    recommendedMethod: 0, // No method needed for decline
                };

                // Submit decline response
                const result = await recommendationService.submitRecommendation(
                    submitData
                );

                if (result.success) {
                    this.submitted = true;
                    window.scrollTo(0, 0);
                } else {
                    this.validationError =
                        result.message ||
                        "Failed to submit your response. Please try again.";
                }
            } catch (err) {
                this.validationError =
                    "An unexpected error occurred. Please try again later.";
                console.error("Error submitting decline:", err);
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>
